import React from 'react';
import { useOnboardingWalkthrough } from '../../context/OnboardingWalkthroughContext';

/**
 * Debug button to reset and restart the walkthrough
 * Add this component anywhere in your app for testing
 */
const WalkthroughResetButton = () => {
  const { resetWalkthrough, startWalkthrough } = useOnboardingWalkthrough();

  const handleReset = () => {
    // Reset the walkthrough state
    resetWalkthrough();
    
    // Start it again after a brief delay
    setTimeout(() => {
      startWalkthrough();
    }, 300);
  };

  return (
    <button
      onClick={handleReset}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        padding: '12px 20px',
        backgroundColor: '#4F46E5',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '600',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        zIndex: 9999,
        transition: 'all 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = '#4338CA';
        e.target.style.transform = 'translateY(-2px)';
        e.target.style.boxShadow = '0 6px 8px rgba(0, 0, 0, 0.15)';
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = '#4F46E5';
        e.target.style.transform = 'translateY(0)';
        e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
      }}
      title="Reset and restart the onboarding walkthrough"
    >
      🔄 Reset Walkthrough
    </button>
  );
};

export default WalkthroughResetButton;
